import React from 'react';
import { IconProps } from '../../../../../types/components';

export default function ArrowRight({ iconClass, width }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 21 12"
      className={iconClass}
      width={width}
    >
      <path d="M20.0039 6.57422L15.2227 11.3555L14.625 11.9531L13.4648 10.7578L14.0625 10.1602L17.4023 6.82031H0V5.13281H17.4023L14.0625 1.79297L13.4648 1.19531L14.625 0L15.2227 0.597656L20.0039 5.37891L20.6016 5.97656L20.0039 6.57422Z" />
    </svg>
  );
}
